(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class FaubourgAnnouncementBar extends HTMLElement {
    connectedCallback() {
      // What the bar takes from the first screen, for a surface that has to
      // end at its foot: the setting until measured, the real height once a
      // line wraps, and nothing once the shopper has dismissed it.
      if (typeof ResizeObserver === 'function') {
        this.heightObserver = new ResizeObserver(this.publishHeight);
        this.heightObserver.observe(this);
      }

      this.dismissButton = this.querySelector('[data-announcement-dismiss]');

      if (this.dismissButton) {
        // The merchant is shown the bar they are editing, whatever they
        // dismissed while previewing the storefront.
        if (!window.Shopify?.designMode && this.readDismissed()) {
          this.hidden = true;
          return;
        }
        this.dismissButton.hidden = false;
        this.dismissButton.addEventListener('click', this.onDismiss);
      }

      this.items = [...this.querySelectorAll('[data-announcement-item]')];
      if (this.items.length < 2) return;

      // Served reachable, for a page with no script to move them; from here
      // only the message on the screen is. A bar the editor reconnects keeps
      // the one it was showing.
      this.current = Math.max(this.items.findIndex((item) => item.classList.contains('is-current')), 0);
      this.items.forEach((item, index) => {
        item.classList.toggle('is-current', index === this.current);
        if (index === this.current) item.removeAttribute('inert');
        else item.setAttribute('inert', '');
      });
      this.setAttribute('data-enhanced', '');
      this.navButtons = [...this.querySelectorAll('[data-announcement-step]')];
      for (const button of this.navButtons) {
        button.hidden = false;
        button.addEventListener('click', this.onStep);
      }

      this.toggle = this.querySelector('[data-announcement-toggle]');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (this.toggle && !this.reduced.matches) {
        this.toggle.hidden = false;
        this.toggle.addEventListener('click', this.onToggle);
      }

      this.paused = false;
      this.start();

      this.addEventListener('pointerenter', this.stop);
      this.addEventListener('pointerleave', this.start);
      this.addEventListener('focusin', this.stop);
      this.addEventListener('focusout', this.start);

      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      this.stop();
      this.heightObserver?.disconnect();
      // Moved or redrawn, a bar is back by the end of this task and publishes
      // its own height; gone for good, what it reserved goes with it.
      queueMicrotask(() => {
        if (!document.querySelector('faubourg-announcement-bar')) {
          document.documentElement.style.removeProperty('--announcement-bar-height');
        }
      });
      this.dismissButton?.removeEventListener('click', this.onDismiss);
      this.toggle?.removeEventListener('click', this.onToggle);
      for (const button of this.navButtons || []) button.removeEventListener('click', this.onStep);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    publishHeight = () => {
      const height = this.hidden ? 0 : this.offsetHeight;
      document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
    };

    get storageKey() {
      return `faubourg:announcement-dismissed:${this.dataset.announcementKey || 'default'}`;
    }

    get motionDuration() {
      const declared = getComputedStyle(this).getPropertyValue('--motion-base');
      return parseFloat(declared) || 0;
    }

    readDismissed() {
      try {
        return window.localStorage.getItem(this.storageKey) === '1';
      } catch {
        return false;
      }
    }

    onDismiss = () => {
      try {
        window.localStorage.setItem(this.storageKey, '1');
      } catch {
        /* Without storage the dismissal holds for this page view only. */
      }

      this.stop();

      this.style.setProperty('--bar-collapse', `${this.offsetHeight}px`);
      this.setAttribute('data-dismissing', '');
      window.setTimeout(this.finishDismiss, this.motionDuration);
    };

    finishDismiss = () => {
      // The cross that was pressed is about to leave with the bar: the focus
      // goes on to what follows it rather than to the top of the page.
      if (this.contains(document.activeElement)) {
        const reachable = 'a[href], button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"])';
        const next = [...document.querySelectorAll(reachable)].find(
          (control) =>
            !this.contains(control) &&
            this.compareDocumentPosition(control) & Node.DOCUMENT_POSITION_FOLLOWING &&
            control.getClientRects().length > 0 &&
            !control.closest('[inert], [hidden]')
        );
        next?.focus();
      }

      this.hidden = true;
      this.removeAttribute('data-dismissing');
      this.style.removeProperty('--bar-collapse');
    };

    get interval() {
      return Number(this.dataset.autoplay || 0) * 1000;
    }

    onToggle = () => {
      this.paused = !this.paused;
      const { labelPause, labelPlay } = this.toggle.dataset;
      this.toggle.textContent = this.paused ? labelPlay : labelPause;
      if (this.paused) {
        this.stop();
      } else {
        this.start();
      }
    };

    start = () => {
      this.stop();
      if (this.paused || !this.interval || this.reduced?.matches) return;
      this.timer = setInterval(() => this.step(1), this.interval);
      this.announceSteps();
    };

    stop = () => {
      clearInterval(this.timer);
      this.timer = null;
      this.announceSteps();
    };

    // A slide that changes by itself is not announced over what the shopper is
    // reading; one they step to is.
    announceSteps() {
      this.querySelector('.announcement-bar__track[aria-live]')?.setAttribute('aria-live', this.timer ? 'off' : 'polite');
    }

    onStep = (event) => {
      const button = event.currentTarget || event.target;
      this.step(Number(button.dataset.announcementStep));
    };

    onBlockSelect = (event) => {
      const at = this.items.indexOf(event.target);
      if (at === -1) return;
      this.stop();
      this.show(at, at > this.current ? 'next' : 'prev');
    };

    step(delta) {
      const total = this.items.length;
      this.show((this.current + delta + total) % total, delta < 0 ? 'prev' : 'next');
    }

    show(next, direction) {
      if (next === this.current) return;

      const leaving = this.items[this.current];
      const entering = this.items[next];

      leaving.classList.remove('is-current');
      leaving.classList.add('is-leaving');
      leaving.setAttribute('inert', '');

      // Muted while the resting offset flips with the direction, or the
      // incoming slide travels the whole way across before it begins.
      entering.style.transition = 'none';
      entering.classList.remove('is-leaving');
      this.dataset.direction = direction;
      void entering.offsetWidth;
      entering.style.transition = '';

      entering.classList.add('is-current');
      entering.removeAttribute('inert');

      this.current = next;
    }
  }

  if (!customElements.get('faubourg-announcement-bar')) {
    customElements.define('faubourg-announcement-bar', FaubourgAnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  /*
   * The drawer surface, registered as the page loads rather than with the cart
   * module above. Opening the drawer needs nothing but the drawer primitive and
   * the cart Shopify already rendered into it, and it is registering the element
   * that swaps the header's `/cart` link for its drawer trigger. Left to the
   * lazy import, that swap happened only after the shopper had already
   * interacted -- so the first click on the cart icon, on every page load, spent
   * itself on a navigation the shopper had not asked for.
   *
   * No Drawer means no registration: the trigger stays hidden, the link stays
   * visible, and `/cart` remains the operable path.
   */
  (function () {
    var Drawer = window.Faubourg && window.Faubourg.Drawer;
    if (!Drawer) return;
    if (customElements.get('faubourg-cart-drawer')) return;

    class CartDrawer extends Drawer {}
    customElements.define('faubourg-cart-drawer', CartDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('faubourg-header')) {
    customElements.define(
      'faubourg-header',
      class FaubourgHeader extends HTMLElement {
        // The header leaves on distance the page has travelled one way, not on
        // the few pixels a trackpad drifts by: it goes after a deliberate move
        // down, and comes back sooner, for a shopper looking for it.
        static HIDE_AFTER = 32;

        static SHOW_AFTER = 12;

        // The ground the section paints under a transparent header reaches this
        // many header heights (`--header-ground-reach`).
        static GROUND_REACH = 2;

        // How far ahead of that reach the header turns solid, in header heights.
        // The script hears where the page is a frame after it got there, and a
        // fast flick covers a tenth of the header in that frame; turning early
        // costs nothing, turning late puts the ink on the photograph.
        static GROUND_LEAD = 0.5;

        static HOVER_OPEN_DELAY = 90;

        static HOVER_CLOSE_DELAY = 220;

        static NAV_ROW_TOLERANCE = 1;

        static EDITOR_EVENTS = ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'];

        connectedCallback() {
          this.desktop = window.matchMedia('(min-width: 990px)');
          this.finePointer = window.matchMedia('(pointer: fine)');
          this.height = this.offsetHeight;
          this.restingHeight = this.height;
          this.lastScroll = Math.max(window.scrollY, 0);
          this.lastHeight = document.documentElement.scrollHeight;
          this.travelled = 0;
          this.ticking = false;

          this.navRestoreAt = 0;

          this.hoverTimer = null;

          this.addEventListener('click', this.handlePress, true);
          this.addEventListener('pointerover', this.handlePrime);
          this.addEventListener('transitionend', this.handleOpened);
          this.addEventListener('transitioncancel', this.handleOpened);
          this.addEventListener('toggle', this.handleToggle, true);
          this.addEventListener('keydown', this.handleKeydown);
          this.addEventListener('focusin', this.handleFocusin);
          this.addEventListener('focusout', this.handleFocusout);
          this.desktop.addEventListener('change', this.handleBreakpoint);
          document.addEventListener('click', this.handleDocumentClick);

          document.addEventListener('drawer:open', this.handleDrawerState);
          document.addEventListener('drawer:close', this.handleDrawerState);

          this.resizeObserver = new ResizeObserver(this.handleResize);
          this.resizeObserver.observe(this);

          for (const type of FaubourgHeader.EDITOR_EVENTS) document.addEventListener(type, this.handleEditor);
          document.addEventListener('shopify:block:select', this.handleBlockSelect);
          document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

          if (this.dataset.sticky !== 'none' || this.classList.contains('header--transparent')) {
            window.addEventListener('scroll', this.handleScroll, { passive: true });
            // A page restored halfway down is dressed for where it stands, not
            // for where it was loaded from. The browser may have put it there
            // before this script ran, or put it there after, which the header
            // hears as a scroll from the top: either way it is taken as one.
            this.lastScroll = 0;
            this.updateScrollState();
          }

          if (this.dataset.menuOpenOn === 'hover') {
            this.addEventListener('pointerover', this.handlePointerOver);
            this.addEventListener('pointerleave', this.handlePointerLeave);
          }
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handlePress, true);
          this.removeEventListener('pointerover', this.handlePrime);
          this.removeEventListener('transitionend', this.handleOpened);
          this.removeEventListener('transitioncancel', this.handleOpened);
          this.removeEventListener('toggle', this.handleToggle, true);
          this.removeEventListener('keydown', this.handleKeydown);
          this.removeEventListener('focusin', this.handleFocusin);
          this.removeEventListener('focusout', this.handleFocusout);
          this.desktop.removeEventListener('change', this.handleBreakpoint);
          document.removeEventListener('click', this.handleDocumentClick);
          document.removeEventListener('drawer:open', this.handleDrawerState);
          document.removeEventListener('drawer:close', this.handleDrawerState);
          for (const type of FaubourgHeader.EDITOR_EVENTS) document.removeEventListener(type, this.handleEditor);
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
          document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
          window.removeEventListener('scroll', this.handleScroll);
          cancelAnimationFrame(this.dressingFrame);
          this.resizeObserver.disconnect();
          this.removeEventListener('pointerover', this.handlePointerOver);
          this.removeEventListener('pointerleave', this.handlePointerLeave);
          this.cancelHover();
        }

        // The surface this header lies on, when the page's first section
        // invited it to; the dress is decided by where that surface is. Asked
        // each time, because the editor moves sections without reconnecting
        // the header.
        get overlay() {
          if (!this.classList.contains('header--transparent')) return null;
          return document.querySelector('main > .shopify-section:first-child > [data-header-overlay]');
        }

        handleEditor = () => {
          this.handleResize();
          this.updateCompact(Math.max(window.scrollY, 0));
        };

        // A promotion lives in a closed panel, so selecting its block shows the
        // merchant nothing unless the panel that holds it is opened. The block
        // is drawn once for each place a menu is drawn, all under one id.
        handleBlockSelect = (event) => {
          const id = event.detail && event.detail.blockId;
          const promos = Array.from(document.querySelectorAll('.menu-promo[data-shopify-editor-block]')).filter((promo) => {
            try {
              return JSON.parse(promo.dataset.shopifyEditorBlock).id === id;
            } catch {
              return false;
            }
          });
          if (promos.length === 0) return;

          this.handleBlockDeselect();
          this.classList.remove('header--retracted');
          this.travelled = 0;

          const details = promos.map((promo) => promo.closest('.header-menu__details')).find((panel) => panel && panel.getClientRects().length > 0);
          if (details) {
            this.closeAll(details);
            this.holdInk();
            details.open = true;
            this.revealed = details;
            return;
          }

          const drawer = document.getElementById('menu-drawer');
          const promo = promos.find((candidate) => drawer && drawer.contains(candidate));
          if (promo && drawer.reveal(promo)) this.revealed = drawer;
        };

        handleBlockDeselect = () => {
          const revealed = this.revealed;
          this.revealed = null;
          if (!revealed) return;

          if (revealed instanceof HTMLDetailsElement) {
            this.holdInk();
            revealed.open = false;
          } else {
            revealed.close({ returnFocus: false, reason: 'editor' });
          }
        };

        get disclosures() {
          return Array.from(this.querySelectorAll('details'));
        }

        get hasOpenDisclosure() {
          return this.disclosures.some((details) => details.open);
        }

        closeAll(except, scope = this.disclosures) {
          this.cancelHover();

          for (const details of scope) {
            if (details === except) continue;
            if (except && details.contains(except)) continue;
            if (!details.open) continue;
            this.holdInk();
            details.open = false;
          }
        }

        // Taken before anything the header opens or closes changes its dress,
        // for the one frame in which it does (see `data-dressing`).
        holdInk() {
          this.dataset.dressing = '';
          cancelAnimationFrame(this.dressingFrame);
          this.dressingFrame = requestAnimationFrame(() => {
            this.dressingFrame = requestAnimationFrame(() => {
              delete this.dataset.dressing;
            });
          });
        }

        // A press on a summary opens or closes it as its default action, after
        // this listener: the ink is held first, so the panel and the bar's new
        // dress arrive in the same frame.
        //
        // A pointer that rested on a menu has already opened it, and the press
        // that follows is the same intent arriving a moment later: it used to
        // close the panel the hover had just opened. The keyboard's press
        // (`detail` 0) still toggles.
        handlePress = (event) => {
          if (event.target instanceof Element && event.target.closest('.header__veil')) {
            this.closeAll();
            return;
          }

          const summary = event.target instanceof Element && event.target.closest('summary');
          if (!summary) return;

          const details = summary.parentElement;
          if (event.detail > 0 && details.open && details.dataset.openedBy === 'pointer') {
            delete details.dataset.openedBy;
            event.preventDefault();
            return;
          }

          this.holdInk();
        };

        // What a pointer opened, a pointer may close: hover is the menu's own
        // way of opening, so leaving it closes the menu and nothing else. The
        // localization selector is opened by a press and waits for one -- it
        // used to close the moment the pointer crossed from its toggle onto
        // its own panel, because that crossing counted as leaving the menu.
        closeMenus() {
          this.closeAll(null, this.querySelectorAll('.header-menu__details'));
        }

        handleResize = () => {
          this.measureNavFit();
          this.height = this.offsetHeight;
          if (!this.classList.contains('header--compact') && !this.opening) this.restingHeight = this.height;
          document.documentElement.style.setProperty('--header-height', `${this.height}px`);
          document.documentElement.style.setProperty(
            '--header-ground-reach',
            `${this.restingHeight * FaubourgHeader.GROUND_REACH}px`
          );
          this.updateDress();
        };

        measureNavFit() {
          const list = this.querySelector('.header__nav .header-menu__list');
          if (!list || !this.desktop.matches) return;
          // Folded beside the logo it was measured to fit; its own row is the
          // one to judge it on, once the header opens again.
          if (this.classList.contains('header--compact-fold')) return;

          if (this.classList.contains('header--nav-overflow')) {
            if (window.innerWidth < this.navRestoreAt) return;
            this.classList.remove('header--nav-overflow');
          }

          const items = Array.from(list.children);
          if (items.length === 0) return;

          const top = items[0].getBoundingClientRect().top;
          const wrapped = items.some((item) => item.getBoundingClientRect().top - top > FaubourgHeader.NAV_ROW_TOLERANCE);

          if (!wrapped) {
            this.navRestoreAt = 0;
            return;
          }

          const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
          const wanted = items.reduce(
            (total, item) => total + item.getBoundingClientRect().width,
            gap * (items.length - 1)
          );
          const short = Math.max(wanted - list.getBoundingClientRect().width, 1);

          const share = this.classList.contains('header--logo-center') ? 2 : 1;
          this.navRestoreAt = window.innerWidth + short * share + 1;
          this.classList.add('header--nav-overflow');
        }

        navHandsOff() {
          this.measureNavFit();
          return this.classList.contains('header--nav-overflow');
        }

        handleScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            this.ticking = false;
            this.updateScrollState();
          });
        };

        updateScrollState() {
          this.updateDress();

          const current = Math.max(window.scrollY, 0);
          this.updateCompact(current);
          const delta = current - this.lastScroll;
          this.lastScroll = current;

          // What the page adds or takes away above the screen moves it by as
          // much while nothing the shopper sees moves: the browser's scroll
          // anchoring, or the script that changed the page, holds their place.
          // That is the page travelling, not the shopper. Only a page that has
          // changed height can travel: with nothing grown, a pixel's move is a
          // slow hand's.
          const height = document.documentElement.scrollHeight;
          const grown = height - this.lastHeight;
          this.lastHeight = height;
          if (grown !== 0 && delta !== 0 && Math.abs(delta - grown) <= 1) return;

          if (this.dataset.sticky !== 'scroll_up' || delta === 0) return;

          // Where the header stands in the page it is in nobody's way.
          if (current <= this.restingFoot) {
            this.travelled = 0;
            this.classList.remove('header--retracted');
            return;
          }

          // Distance in one direction, counted again whenever the page turns.
          if (Math.sign(delta) !== Math.sign(this.travelled)) this.travelled = 0;
          this.travelled += delta;

          if (this.travelled >= FaubourgHeader.HIDE_AFTER) {
            // Held, the header lets the distance go: once the shopper is done
            // with it, leaving takes a fresh deliberate scroll, not a nudge.
            if (this.holdsPlace) this.travelled = 0;
            else this.classList.add('header--retracted');
          } else if (this.travelled <= -FaubourgHeader.SHOW_AFTER) {
            this.classList.remove('header--retracted');
          }
        }

        // The foot of the header where the page first puts it, under the
        // announcement bar, at its full height.
        get restingFoot() {
          const root = getComputedStyle(document.documentElement);
          return (parseFloat(root.getPropertyValue('--announcement-bar-height')) || 0) + this.restingHeight;
        }

        // Drawn in once the page has moved past the header's resting place,
        // and while it is solid: a header lying over a photograph stays open.
        updateCompact(current) {
          if (this.dataset.sticky === 'none') return;
          const solid = !this.overlay || this.classList.contains('header--scrolled');
          const compact = solid && current > this.restingFoot;
          if (compact === this.classList.contains('header--compact')) return;

          // Opening again, the header is still its compact height for a while:
          // its full height is only read once it has finished growing back.
          const inner = this.querySelector('.header__inner');
          const animates = inner && parseFloat(getComputedStyle(inner).transitionDuration) > 0;
          this.opening = !compact && animates;

          const fold = compact && this.menuFitsBesideLogo();
          const nav = this.querySelector('.header__nav');
          const from = fold !== this.classList.contains('header--compact-fold') ? nav?.getBoundingClientRect() : null;
          this.classList.toggle('header--compact-fold', fold);
          this.classList.toggle('header--compact', compact);
          if (from) this.glide(nav, from);
        }

        // The menu crosses between rows from where it stood rather than
        // appearing there: a move made as a transform, at the header's pace,
        // which the page does not count as its layout shifting.
        glide(element, from) {
          const to = element.getBoundingClientRect();
          const style = getComputedStyle(this);
          const duration = parseFloat(style.getPropertyValue('--motion-base')) || 0;
          if (!duration || (from.left === to.left && from.top === to.top)) return;
          element.animate(
            [{ transform: `translate(${from.left - to.left}px, ${from.top - to.top}px)` }, { transform: 'none' }],
            { duration, easing: style.getPropertyValue('--motion-ease').trim() }
          );
        }

        // Whether the menu, measured on its own row, fits the side a folded
        // logo leaves it: the row less the logo, halved.
        menuFitsBesideLogo() {
          if (!this.classList.contains('header--logo-top-center') || !this.desktop.matches) return false;
          if (this.classList.contains('header--nav-drawer') || this.classList.contains('header--nav-overflow')) return false;
          const inner = this.querySelector('.header__inner');
          const list = this.querySelector('.header__nav .header-menu__list');
          const logo = this.querySelector('.header__logo');
          if (!inner || !list || !logo) return false;

          const style = getComputedStyle(inner);
          const row = inner.clientWidth - parseFloat(style.paddingInlineStart) - parseFloat(style.paddingInlineEnd);
          const gap = parseFloat(style.columnGap) || 0;
          const items = Array.from(list.children);
          const listGap = parseFloat(getComputedStyle(list).columnGap) || 0;
          const wanted = items.reduce((total, item) => total + item.getBoundingClientRect().width, listGap * (items.length - 1));
          return wanted <= (row - logo.getBoundingClientRect().width - 2 * gap) / 2;
        }

        handleOpened = (event) => {
          if (!this.opening || event.target !== this.querySelector('.header__inner') || !event.propertyName.startsWith('padding')) return;
          this.opening = false;
          this.handleResize();
        };

        // What a shopper is using stays: an open panel, or a control the
        // keyboard is on. Focus a drawer handed back after a pointer closed
        // it is not that, and used to pin the header for the rest of the page.
        get holdsPlace() {
          return this.hasOpenDisclosure || this.matches(':has(:focus-visible)');
        }

        // Transparent while the surface that invited it is beneath the header
        // with room for its ground; solid once that surface's foot comes within
        // the ground's reach, because from there the ground is being pushed off
        // the rows the ink stands on. Turning solid a little early costs
        // nothing -- solid carries its own ground -- and turning late would.
        updateDress() {
          if (!this.overlay) return;
          // From the header's full height: measured from the compact one, the
          // line would move as the header crossed it, and the header flap.
          const reach = this.restingHeight * (FaubourgHeader.GROUND_REACH + FaubourgHeader.GROUND_LEAD);
          this.dress(this.overlay.getBoundingClientRect().bottom <= reach);
        }

        dress(solid) {
          if (this.classList.contains('header--scrolled') === solid) return;
          this.holdInk();
          this.classList.toggle('header--scrolled', solid);
        }

        handleToggle = (event) => {
          const details = event.target;
          if (!(details instanceof HTMLDetailsElement)) return;
          if (!details.open) delete details.dataset.openedBy;
          if (details.open) this.closeAll(details);
        };

        handleKeydown = (event) => {
          if (event.key !== 'Escape') return;

          const open = this.disclosures.filter((details) => details.open);
          if (open.length === 0) return;

          const innermost = open[open.length - 1];
          const summary = innermost.querySelector('summary');
          this.holdInk();
          innermost.open = false;
          if (summary) summary.focus();
        };

        handleDocumentClick = (event) => {
          if (this.contains(event.target)) return;
          this.closeAll();
        };

        handleBreakpoint = (event) => {
          if (!event.matches) return;
          this.closeAll();
        };

        // A panel belongs to the focus inside it. Keyboard focus that moves on --
        // to the next item, or out of the header -- closes what it left, as the
        // pointer leaving does, rather than leaving a panel over the content
        // the shopper went on to.
        handleFocusin = (event) => {
          this.classList.remove('header--retracted');
          this.travelled = 0;
          this.handlePrime(event);

          for (const details of this.disclosures) {
            if (!details.open || details.contains(event.target)) continue;
            this.holdInk();
            details.open = false;
          }
        };

        handleFocusout = (event) => {
          const next = event.relatedTarget;
          if (!(next instanceof Node) || this.contains(next)) return;
          this.closeAll();
        };

        cancelHover() {
          if (this.hoverTimer === null) return;
          clearTimeout(this.hoverTimer);
          this.hoverTimer = null;
        }

        scheduleHover(delay, action) {
          this.cancelHover();
          this.hoverTimer = setTimeout(() => {
            this.hoverTimer = null;
            action();
          }, delay);
        }

        // A panel's pictures wait, lazily, for the panel to open, and then
        // arrive a moment after it. The pointer or the keyboard reaching its
        // summary already says it is about to: they are sent for then. A
        // shopper who never goes near the menu fetches none of them.
        primePictures(details) {
          if (!details || details.dataset.primed) return;
          details.dataset.primed = '';
          for (const image of details.querySelectorAll('img[loading="lazy"]')) image.loading = 'eager';
        }

        handlePrime = (event) => {
          if (event.target instanceof Element) this.primePictures(event.target.closest('.header-menu__details'));
        };

        handlePointerOver = (event) => {
          if (!this.finePointer.matches || !this.desktop.matches) return;

          const details = event.target.closest('.header-menu__details');

          if (!details) {
            this.scheduleHover(FaubourgHeader.HOVER_CLOSE_DELAY, () => this.closeMenus());
            return;
          }

          if (details.open) {
            this.cancelHover();
            return;
          }

          this.scheduleHover(FaubourgHeader.HOVER_OPEN_DELAY, () => {
            this.closeAll(details);
            this.holdInk();
            details.dataset.openedBy = 'pointer';
            details.open = true;
          });
        };

        handlePointerLeave = () => {
          if (!this.finePointer.matches || !this.desktop.matches) return;
          this.scheduleHover(FaubourgHeader.HOVER_CLOSE_DELAY, () => this.closeMenus());
        };

        handleDrawerState = (event) => {
          const id = event.detail && event.detail.id;
          if (id !== 'menu-drawer') return;
          this.holdInk();
          this.classList.toggle('header--menu-open', event.type === 'drawer:open');
        };
      }
    );
  }

  (function () {
    var Drawer = window.Faubourg && window.Faubourg.Drawer;
    if (!Drawer) return;

    var DESKTOP = '(min-width: 990px)';

    class MenuDrawer extends Drawer {
      #desktop = null;

      #nav = null;
      #track = null;
      #panels = [];
      #chain = [];
      #triggerByPanel = new WeakMap();
      #titleByPanel = new WeakMap();
      #localization = null;

      #onBreakpoint = (event) => {
        if (!event.matches) return;

        if (this.classList.contains('drawer--persistent')) return;

        const header = document.querySelector('.header');
        if (header && typeof header.navHandsOff === 'function' && header.navHandsOff()) return;

        const wasFocused = this.contains(document.activeElement);

        this.close({ returnFocus: false, reason: 'breakpoint' });

        if (!wasFocused) return;

        const landings = [
          document.querySelector('.header__nav'),
          document.querySelector('.header__utilities'),
          document.querySelector('.header__logo'),
        ];

        for (const landing of landings) {
          if (Drawer.focusFirst(landing)) return;
        }
      };

      #onPanelKeydown = (event) => {
        if (event.key !== 'Escape') return;
        if (this.#chain.length <= 1) return;

        event.stopPropagation();
        event.preventDefault();
        this.#drillBack();
      };

      connectedCallback() {
        super.connectedCallback();

        this.#desktop = window.matchMedia(DESKTOP);
        this.#desktop.addEventListener('change', this.#onBreakpoint);

        this.#buildPanels();
        this.addEventListener('keydown', this.#onPanelKeydown);
      }

      disconnectedCallback() {
        if (this.#desktop) {
          this.#desktop.removeEventListener('change', this.#onBreakpoint);
          this.#desktop = null;
        }

        this.removeEventListener('keydown', this.#onPanelKeydown);

        super.disconnectedCallback();
      }

      open(options) {
        const opened = super.open(options);
        if (opened) this.#resetPanels();
        return opened;
      }

      close(options) {
        const closed = super.close(options);
        if (closed) this.#resetPanels();
        return closed;
      }

      // Opens on the panel holding `element`, for the editor to show a block
      // that sits a drill deep.
      reveal(element) {
        const panel = element.closest('[data-menu-panel]');
        if (!panel || !this.#panels.includes(panel)) return false;

        // Already open on another panel, the drawer is not reopened, so it is
        // not reset either: the panel is reached from the root, not from there.
        const wasOpen = this.isOpen;
        this.open({ reason: 'editor' });
        if (wasOpen && this.#chain[this.#chain.length - 1] !== panel) this.#resetPanels();
        if (this.#chain.includes(panel)) return true;

        this.#chain.push(panel);
        this.#syncPanels();
        this.#triggerByPanel.get(panel)?.setAttribute('aria-expanded', 'true');
        this.#writeTrail();
        return true;
      }

      #buildPanels() {
        const nav = this.querySelector('.menu-nav');
        if (!nav) return;

        const list = nav.querySelector(':scope > .menu-nav__list');
        if (!list) return;

        this.#localization = this.querySelector('.menu-nav__localization');

        const track = document.createElement('div');
        track.className = 'menu-nav__track';
        nav.insertBefore(track, list);
        track.appendChild(list);

        this.#nav = nav;
        this.#track = track;
        this.#panels = [list];

        const detailsList = Array.prototype.slice.call(list.querySelectorAll('details.menu-nav__details'));
        detailsList.forEach((details) => this.#convertDetails(details, track));

        this.querySelector('[data-drawer-back]')?.addEventListener('click', () => this.#drillBack());

        nav.classList.add('menu-nav--paneled');
        this.#chain = [list];
        this.#syncPanels();
      }

      #convertDetails(details, track) {
        const summary = details.querySelector(':scope > summary.menu-nav__summary');
        const panel = details.querySelector(':scope > .menu-nav__panel');
        if (!summary || !panel) return;

        track.appendChild(panel);
        this.#panels.push(panel);

        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = summary.className;
        trigger.innerHTML = summary.innerHTML;
        panel.id ||= `${this.id || 'menu'}-panel-${this.#panels.length}`;
        trigger.setAttribute('aria-controls', panel.id);
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', () => this.#drillInto(panel));

        this.#triggerByPanel.set(panel, trigger);
        this.#titleByPanel.set(panel, summary.textContent.trim());
        details.replaceWith(trigger);
      }

      #drillInto(panel) {
        this.#chain.push(panel);
        this.#syncPanels();

        const trigger = this.#triggerByPanel.get(panel);
        if (trigger) trigger.setAttribute('aria-expanded', 'true');

        this.#writeTrail()?.focus();
      }

      #drillBack() {
        if (this.#chain.length <= 1) return;

        const leaving = this.#chain.pop();
        this.#syncPanels();
        this.#writeTrail();

        const trigger = this.#triggerByPanel.get(leaving);
        if (!trigger) return;

        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }

      #resetPanels() {
        if (this.#panels.length === 0) return;

        const root = this.#panels[0];
        if (this.#chain.length === 1 && this.#chain[0] === root) return;

        this.#panels.forEach((panel) => {
          const trigger = this.#triggerByPanel.get(panel);
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        });

        this.#chain = [root];
        this.#writeTrail();
        this.#syncPanels({ instant: true });
      }

      #writeTrail() {
        const steps = this.#chain.slice(1).map((panel) => this.#titleByPanel.get(panel) || '');
        return window.Faubourg.overlayTrail(this, steps);
      }

      #syncPanels(options) {
        const settings = options || {};
        const activeIndex = this.#chain.length - 1;
        const active = this.#chain[activeIndex];

        const applyStates = () => {
          this.#panels.forEach((panel) => {
            const chainIndex = this.#chain.indexOf(panel);

            if (panel === active) {
              panel.dataset.panelState = 'active';
              panel.removeAttribute('inert');
            } else if (chainIndex !== -1) {
              panel.dataset.panelState = 'prev';
              panel.setAttribute('inert', '');
            } else {
              panel.dataset.panelState = 'next';
              panel.setAttribute('inert', '');
            }
          });

          if (!this.#localization) return;
          if (activeIndex > 0) this.#localization.setAttribute('inert', '');
          else this.#localization.removeAttribute('inert');
        };

        if (!settings.instant || !this.#nav) {
          applyStates();
          return;
        }

        this.#nav.classList.add('menu-nav--instant');
        applyStates();
        this.#nav.offsetHeight;
        this.#nav.classList.remove('menu-nav--instant');
      }
    }

    if (!customElements.get('faubourg-menu-drawer')) {
      customElements.define('faubourg-menu-drawer', MenuDrawer);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class FaubourgHero extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.rail = this.querySelector('[data-hero-rail]');
      if (!this.rail) return;

      this.indices = [...this.rail.querySelectorAll('[data-hero-index]')];
      this.toggle = this.rail.querySelector('[data-hero-toggle]');
      // Where the band already stands: the editor reconnects a section it
      // re-renders, and the slide showing then need not be the first.
      this.current = Math.max(this.slides.findIndex((slide) => !slide.hidden), 0);
      this.visible = true;

      // Under reduced motion nothing here starts on its own; the shopper's
      // own press, remembered for the visit, outranks it either way.
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.readPaused() ?? this.reduced.matches;
      this.renderPaused();
      this.toggle?.addEventListener('click', this.onToggle);

      this.rail.hidden = false;
      this.rail.addEventListener('click', this.onClick);

      for (const film of this.querySelectorAll('[data-hero-video]')) {
        film.addEventListener('playing', () => film.setAttribute('data-playing', ''));
      }

      // A film plays only while its band is on the screen, and never before
      // the page has finished loading what it opened with.
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.syncFilm();
      });
      this.observer.observe(this);

      this.start();

      this.addEventListener('pointerenter', this.stop);
      this.addEventListener('pointerleave', this.start);
      this.addEventListener('focusin', this.stop);
      this.addEventListener('focusout', this.start);

      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    disconnectedCallback() {
      this.stop();
      this.observer?.disconnect();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      this.rail?.removeEventListener('click', this.onClick);
      this.toggle?.removeEventListener('click', this.onToggle);
    }

    get interval() {
      return Number(this.dataset.autoplay || 0) * 1000;
    }

    get storageKey() {
      return `faubourg:hero-paused:${this.dataset.heroKey || 'default'}`;
    }

    // The shopper's last press, or nothing where they have not pressed.
    readPaused() {
      try {
        const stored = window.sessionStorage.getItem(this.storageKey);
        return stored === null ? null : stored === '1';
      } catch {
        return null;
      }
    }

    writePaused(value) {
      try {
        window.sessionStorage.setItem(this.storageKey, value ? '1' : '0');
      } catch {}
    }

    renderPaused() {
      this.toggleAttribute('data-paused', this.paused);
      if (!this.toggle) return;
      for (const state of this.toggle.querySelectorAll('[data-hero-toggle-state]')) {
        state.toggleAttribute('data-inactive', state.dataset.heroToggleState !== (this.paused ? 'play' : 'pause'));
      }
    }

    onToggle = () => {
      this.paused = !this.paused;
      this.writePaused(this.paused);
      this.renderPaused();
      this.syncFilm();
      if (this.paused) {
        this.stop();
      } else {
        this.start();
      }
    };

    start = () => {
      this.stop();
      if (this.selected || this.paused || !this.interval || this.slides.length < 2) return;
      this.timer = setInterval(() => this.show((this.current + 1) % this.slides.length), this.interval);
    };

    stop = () => {
      clearInterval(this.timer);
      this.timer = null;
    };

    // The merchant editing a slide sees it, and the band does not move on
    // while a block of it is selected, whether or not the pointer is over it.
    onBlockSelect = (event) => {
      const at = this.slides.indexOf(event.target);
      if (at === -1) return;
      this.selected = true;
      this.stop();
      this.show(at);
    };

    onBlockDeselect = (event) => {
      if (!this.slides.includes(event.target)) return;
      this.selected = false;
      this.start();
    };

    onClick = (event) => {
      const button = event.target.closest('[data-hero-index]');
      if (!button || !this.rail.contains(button)) return;
      this.show(Number(button.dataset.heroIndex));
    };

    // The shown slide's film plays while nothing holds it; every other film
    // is paused, so a slide the shopper left is not still running unseen.
    syncFilm() {
      if (document.readyState !== 'complete') {
        if (!this.awaitingLoad) {
          this.awaitingLoad = true;
          window.addEventListener('load', () => this.syncFilm(), { once: true });
        }
        return;
      }
      this.slides.forEach((slide, index) => {
        const film = slide.querySelector('[data-hero-video]');
        if (!film) return;
        if (index === this.current && this.visible && !this.paused) {
          film.play()?.catch(() => {});
        } else {
          film.pause();
        }
      });
    }

    show(next) {
      if (next === this.current) return;

      this.slides[this.current].hidden = true;
      this.indices[this.current]?.removeAttribute('aria-current');

      this.setAttribute('data-hero-moved', '');
      this.slides[next].hidden = false;
      this.indices[next]?.setAttribute('aria-current', 'true');

      const fill = this.indices[next]?.querySelector('.hero__index-fill');
      if (fill) {
        fill.style.animation = 'none';
        void fill.offsetWidth;
        fill.style.animation = '';
      }

      this.current = next;
      this.syncFilm();
    }
  }

  if (!customElements.get('faubourg-hero')) {
    customElements.define('faubourg-hero', FaubourgHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductInfoPanel extends HTMLElement {
    connectedCallback() {
      if (typeof ResizeObserver !== 'function') return;
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this);
      this.measure();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    measure() {
      const top = this.getBoundingClientRect().top;
      const decision = this.querySelector('.product-variant-picker, .product-buy-buttons');
      const start = decision ? Math.max(0, decision.getBoundingClientRect().top - top) : 0;

      this.style.setProperty('--panel-height', `${Math.ceil(this.offsetHeight)}px`);
      this.style.setProperty('--panel-decision-start', `${Math.floor(start)}px`);
    }
  }

  if (!customElements.get('product-info-panel')) {
    customElements.define('product-info-panel', ProductInfoPanel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var Drawer = window.Faubourg && window.Faubourg.Drawer;
    if (!Drawer) return;

    // Once a visit, and never again to a shopper who subscribed through it.
    // Storage can be refused outright; the pop-up then opens on every page
    // rather than throwing.
    function remembered(store, key) {
      try {
        return window[store].getItem(key) !== null;
      } catch (error) {
        return false;
      }
    }

    function remember(store, key) {
      try {
        window[store].setItem(key, '1');
      } catch (error) {}
    }

    // The editor reports a selection only as it changes, and a changed
    // setting re-renders the section: the new element reads it from here.
    var selected = null;

    class Popup extends Drawer {
      #cue = null;
      #signal = null;

      connectedCallback() {
        super.connectedCallback();

        var root = this.querySelector('[data-popup]');
        if (!root) return;

        this.sectionId = root.dataset.sectionId;
        this.key = 'faubourg:popup:' + this.sectionId;

        if (window.Shopify && window.Shopify.designMode) {
          if (selected === this.sectionId) this.open({ reason: 'editor' });
          return;
        }

        // A sign-up made here answers here: Shopify brings the post back to
        // the page with the form's id as the fragment. The id is ASCII a URL
        // never escapes, so the fragment is read as it stands: decoding it
        // would throw on a stray `%` and leave the pop-up unarmed.
        var answered = window.location.hash ? document.getElementById(window.location.hash.slice(1)) : null;
        if (answered && this.contains(answered)) {
          if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
            remember('localStorage', this.key);
          }
          remember('sessionStorage', this.key);
          this.open({ reason: 'answer' });
          return;
        }

        if (remembered('localStorage', this.key) || remembered('sessionStorage', this.key)) return;

        var controller = new AbortController();
        this.#signal = controller;
        var delay = Math.max(Number(root.dataset.delay) || 0, 0) * 1000;

        // Counted from load, so the page's largest paint is never the one
        // under the veil.
        if (document.readyState === 'complete') {
          this.#arm(delay);
        } else {
          window.addEventListener('load', () => this.#arm(delay), { once: true, signal: controller.signal });
        }
      }

      disconnectedCallback() {
        window.clearTimeout(this.#cue);
        if (this.#signal) this.#signal.abort();
        this.#signal = null;
        super.disconnectedCallback();
      }

      #arm(delay) {
        window.clearTimeout(this.#cue);
        this.#cue = window.setTimeout(() => this.#fire(delay), delay);
      }

      // Not over a drawer the shopper opened, nor under their typing: the cue
      // waits its length again and asks once more.
      #fire(delay) {
        var focused = document.activeElement;
        var busy =
          document.documentElement.hasAttribute('data-drawer-open') ||
          (focused && focused.matches('input, textarea, select, [contenteditable]'));
        if (busy) {
          this.#arm(delay);
          return;
        }

        if (this.open({ reason: 'cue', trigger: focused })) remember('sessionStorage', this.key);
      }
    }

    if (!customElements.get('faubourg-popup')) {
      customElements.define('faubourg-popup', Popup);
    }

    if (!(window.Shopify && window.Shopify.designMode)) return;

    function popupOf(event) {
      var popup = document.getElementById('popup-' + event.detail.sectionId);
      return popup instanceof Popup ? popup : null;
    }

    function select(event) {
      selected = event.detail.sectionId;
      var popup = popupOf(event);
      if (popup) popup.open({ reason: 'editor' });
    }

    document.addEventListener('shopify:section:select', select);
    document.addEventListener('shopify:block:select', select);
    document.addEventListener('shopify:section:deselect', function (event) {
      if (selected === event.detail.sectionId) selected = null;
      var popup = popupOf(event);
      if (popup) popup.close({ reason: 'editor' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  class FaubourgVideo extends HTMLElement {
    connectedCallback() {
      this.poster = this.querySelector('[data-video-poster]');
      this.stage = this.querySelector('[data-video-stage]');
      this.video = this.querySelector('video');
      this.embed = this.querySelector('[data-video-embed]');
      this.playButton = this.querySelector('[data-video-play]');

      // Pressing play hides the button that was pressed, so focus goes with
      // the shopper to the player they started rather than into nothing.
      this.playButton?.addEventListener('click', () => {
        this.play(false);
        (this.video || this.embed?.firstElementChild)?.focus();
      });

      if (this.dataset.autoplay === undefined) return;

      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (reduced.matches) return;

      this.play(true);
    }

    play(muted) {
      if (this.embed && !this.embed.firstElementChild) {
        this.embed.appendChild(this.buildEmbed(muted));
      }

      if (this.poster) this.poster.hidden = true;
      if (this.stage) this.stage.hidden = false;

      if (this.video) {
        this.video.muted = muted;
        this.video.play?.().catch(() => {});
      }
    }

    buildEmbed(muted) {
      const iframe = document.createElement('iframe');
      iframe.className = 'video__media';
      iframe.title = this.dataset.title || '';
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;

      const { src, srcMuted } = this.embed.dataset;
      iframe.src = muted ? srcMuted : src;

      return iframe;
    }
  }

  if (!customElements.get('faubourg-video')) {
    customElements.define('faubourg-video', FaubourgVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
